(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = 'spo-announce-dismissed';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    for (const bar of document.querySelectorAll('.spo-announce')) {
      const slides = Array.from(bar.querySelectorAll('.spo-announce__slide'));
      const pause = bar.querySelector('.spo-announce__pause');
      const close = bar.querySelector('.spo-announce__close');
      const signature = bar.textContent.trim().replace(/\s+/g, ' ');
      let index = 0;
      let timer = 0;
      let hovered = false;
      let focused = false;

      close?.addEventListener('click', () => {
        try {
          sessionStorage.setItem(key, signature);
        } catch (error) {}
        const section = bar.closest('.shopify-section');
        bar.remove();
        section?.setAttribute('hidden', '');
        document.getElementById('header-component')?.querySelector('a, button')?.focus({ preventScroll: true });
      });

      if (slides.length < 2) continue;

      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.toggleAttribute('aria-hidden', i !== index);
          for (const link of slide.querySelectorAll('a')) link.tabIndex = i === index ? 0 : -1;
        });
      };
      const paused = () => pause?.getAttribute('aria-pressed') === 'true';
      const stop = () => {
        window.clearInterval(timer);
        timer = 0;
      };
      const start = () => {
        stop();
        if (reduce.matches || paused() || hovered || focused) return;
        timer = window.setInterval(() => show(index + 1), Number(bar.dataset.interval || 6) * 1000);
      };

      show(0);
      bar.querySelector('.spo-announce__prev')?.addEventListener('click', () => {
        show(index - 1);
        start();
      });
      bar.querySelector('.spo-announce__next')?.addEventListener('click', () => {
        show(index + 1);
        start();
      });
      pause?.addEventListener('click', () => {
        const now = !paused();
        pause.setAttribute('aria-pressed', String(now));
        pause.setAttribute('aria-label', now ? pause.dataset.labelPlay : pause.dataset.labelPause);
        start();
      });
      bar.addEventListener('mouseenter', () => {
        hovered = true;
        stop();
      });
      bar.addEventListener('mouseleave', () => {
        hovered = false;
        start();
      });
      bar.addEventListener('focusin', () => {
        focused = true;
        stop();
      });
      bar.addEventListener('focusout', (event) => {
        if (bar.contains(event.relatedTarget)) return;
        focused = false;
        start();
      });
      reduce.addEventListener('change', start);
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Phones: each link group becomes a disclosure. Desktop / no JS: every list shows. */
    const phone = window.matchMedia('(max-width: 749px)');
    const chevron =
      '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
    const groups = Array.from(document.querySelectorAll('[data-spo-footer-group]'));
    const setup = () => {
      for (const group of groups) {
        const heading = group.querySelector('.spo-footer__h');
        const list = group.querySelector('.spo-footer__list');
        if (!heading || !list) continue;
        const existing = heading.querySelector('.spo-footer__toggle');
        if (phone.matches && !existing) {
          const text = heading.textContent.trim();
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'spo-footer__toggle';
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', list.id);
          button.innerHTML = '<span></span>' + chevron;
          button.firstChild.textContent = text;
          button.addEventListener('click', () => {
            const open = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(open));
            list.hidden = !open;
          });
          heading.replaceChildren(button);
          list.hidden = true;
        } else if (!phone.matches && existing) {
          const span = document.createElement('span');
          span.className = 'spo-footer__h-text';
          span.textContent = existing.textContent.trim();
          heading.replaceChildren(span);
          list.hidden = false;
        }
      }
    };
    setup();
    phone.addEventListener('change', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-home-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    for (const link of document.querySelectorAll('[data-spo-find-vehicle]')) {
      const vehicle = window.spoVehicle?.get();
      if (vehicle) {
        link.href = vehicle.url;
        continue;
      }
      link.addEventListener('click', (event) => {
        if (window.spoVehicle?.focusSearch()) event.preventDefault();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-home-vehicles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Show all / show fewer for the model and make grids. The list starts complete; this only collapses it
       when the script runs, and only when some cards are actually hidden at the current width. */
    for (const toggle of document.querySelectorAll('.spo-expand-toggle[aria-controls]')) {
      const list = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!list) continue;
      const label = toggle.querySelector('.spo-expand-toggle__label');
      const items = Array.from(list.children);
      const hiddenCount = () => items.filter((item) => item.offsetParent === null).length;

      list.classList.add('spo-expand--collapsed');
      const sync = () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.hidden = !open && hiddenCount() === 0;
      };
      sync();
      window.matchMedia('(max-width: 749px)').addEventListener('change', sync);
      window.matchMedia('(max-width: 989px)').addEventListener('change', sync);

      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        const firstHidden = items.find((item) => item.offsetParent === null);
        toggle.setAttribute('aria-expanded', String(open));
        list.classList.toggle('spo-expand--collapsed', !open);
        label.textContent = open ? toggle.dataset.less : toggle.dataset.more;
        if (open && firstHidden) {
          for (const item of items.slice(items.indexOf(firstHidden))) item.classList.add('spo-expand__new');
          window.setTimeout(() => {
            for (const item of items) item.classList.remove('spo-expand__new');
          }, 400);
          firstHidden.querySelector('a')?.focus({ preventScroll: true });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-pdp-aplus"]) return;
  try {
    
  // Owner 14/10 (#51): open on desktop. A phone turned to landscape / a resized window that crosses 750 px opens it.
  (() => {
    const wide = window.matchMedia('(min-width: 750px)');
    wide.addEventListener('change', (event) => {
      if (!event.matches) return;
      for (const accordion of document.querySelectorAll('spo-accordion.spo-acc--aplus')) accordion.setOpen?.(true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-pdp-panel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spo-fitment-table')) {
    class SpoFitmentTable extends HTMLElement {
      connectedCallback() {
        this.rows = [...this.querySelectorAll('tbody tr')];
        this.limit = Number(this.dataset.collapseAfter) || 10;
        this.button = this.querySelector('.spo-fit__toggle');
        this.status = this.querySelector('[data-spo-fit-status]');
        this.chips = [...this.querySelectorAll('[data-spo-chip]')];
        for (const [index, row] of this.rows.entries()) {
          const cells = row.querySelectorAll('td');
          row.dataset.model = cells.length > 1 ? (cells[0].textContent.trim() + ' ' + cells[1].textContent.trim()) : '';
          if (index >= this.limit) row.classList.add('spo-fit__more');
        }
        if (this.button && this.rows.length > this.limit) {
          this.button.hidden = false;
          this.button.addEventListener('click', () => this.#toggle());
          this.#set(true);
        }
        for (const chip of this.chips) chip.addEventListener('click', () => this.filter(chip.dataset.spoChip));
        // Chips and links in the buy-box fit panel ([data-spo-fit-chip], href #vehicle-fitment) filter this table.
        document.addEventListener('click', (event) => {
          const link = event.target instanceof Element && event.target.closest('[data-spo-fit-chip]');
          if (link && !this.contains(link)) this.filter(link.dataset.spoFitChip);
        });
      }

      /** @param {string} model - "Make Model", or '' for all rows. */
      filter(model) {
        let shown = 0;
        for (const row of this.rows) {
          const off = Boolean(model) && row.dataset.model !== model;
          row.classList.toggle('spo-fit__off', off);
          if (!off) shown += 1;
        }
        this.classList.toggle('spo-fit--filtered', Boolean(model));
        for (const chip of this.chips) chip.setAttribute('aria-pressed', String(chip.dataset.spoChip === (model || '')));
        if (this.status) {
          this.status.textContent = '';
          const text = model ? `Showing ${shown} ${model} variant${shown === 1 ? '' : 's'}` : `Showing all ${this.rows.length} variants`;
          window.requestAnimationFrame(() => { this.status.textContent = text; });
        }
      }

      #toggle() {
        const collapsed = this.classList.contains('spo-fit--collapsed');
        this.#set(!collapsed);
        if (!collapsed) this.scrollIntoView({ block: 'nearest' });
      }

      #set(collapsed) {
        this.classList.toggle('spo-fit--collapsed', collapsed);
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.button.textContent = collapsed ? this.dataset.labelMore : this.dataset.labelLess;
      }
    }
    customElements.define('spo-fitment-table', SpoFitmentTable);
  }

  // Specifications (16/10): the table is the theme's own (snippets/spo-pdp-specs.liquid). "At a glance" links to it
  // as "All N specifications", N = the rows in the table.
  (() => {
    const count = () => {
      const n = document.querySelectorAll('#tab-specs .spo-specs__row').length;
      if (n > 0) for (const link of document.querySelectorAll('[data-spo-spec-link]')) link.textContent = `All ${n} specifications`;
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', count, { once: true });
    else count();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-popup-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const card = document.querySelector('dialog.spo-popup');
    if (!card) return;
    const KEY = 'spo-popup-dismissed';
    const SEEN = 'spo-popup-seen';
    const phone = window.matchMedia('(max-width: 749px)');
    const days = Number(card.dataset.days || 30);
    const forced = new URLSearchParams(location.search).has('spo_popup_preview');

    const read = (store, key) => {
      try { return window[store].getItem(key); } catch (error) { return null; }
    };
    const write = (store, key, value) => {
      try { window[store].setItem(key, value); } catch (error) {}
    };

    // After a sign-up (or an error), the page reloads with the form result: show it right away.
    const posted = card.querySelector('[data-spo-popup-posted]');
    if (!posted && !forced) {
      const last = Number(read('localStorage', KEY) || 0);
      if (last && Date.now() - last < days * 864e5) return;
      if (read('sessionStorage', SEEN)) return;
    }

    if (card.dataset.variant === 'vehicle') {
      const vehicle = window.spoVehicle?.get();
      if (!vehicle) return;
      card.querySelector('[data-spo-vehicle-name]').textContent = vehicle.label;
      card.querySelector('[data-spo-vehicle-url]').href = vehicle.url;
    }

    // The build's PDP sticky bar is <spo-sticky-buy> (PDP polish 13/10); .sticky-atc is Ella's own, kept as a fallback.
    const stickyAtc = () => document.querySelector('spo-sticky-buy, .sticky-atc');
    // Shopify's cookie banner is position: fixed (offsetParent is always null), so test its box and style.
    const cookieBannerOpen = () => {
      const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog');
      if (!banner) return false;
      const style = getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      return rect.height > 0 && rect.width > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
    };
    const placeAboveAtc = () => {
      const atc = stickyAtc();
      const rect = atc && atc.getBoundingClientRect();
      const visible = rect && rect.height > 0 && rect.top < window.innerHeight && getComputedStyle(atc).visibility !== 'hidden';
      card.style.setProperty('--spo-popup-offset', visible ? `${Math.round(window.innerHeight - rect.top)}px` : '0px');
    };

    let opened = false;
    let returnFocus = null;
    const open = () => {
      if (opened) return;
      if (phone.matches && stickyAtc()) return;
      if (cookieBannerOpen()) {
        window.setTimeout(open, 1500);
        return;
      }
      opened = true;
      write('sessionStorage', SEEN, '1');
      placeAboveAtc();
      // show() moves focus into the dialog; a non-intrusive card leaves the shopper where they are and is
      // announced politely instead (Tab reaches it; Esc closes it).
      const before = document.activeElement;
      card.show();
      if (before instanceof HTMLElement && before !== document.body) before.focus({ preventScroll: true });
      else if (card.contains(document.activeElement)) document.activeElement.blur();
      const live = card.querySelector('[data-spo-popup-live]');
      if (live) window.setTimeout(() => (live.textContent = live.dataset.text), 100);
    };
    const close = () => {
      write('localStorage', KEY, String(Date.now()));
      const hadFocus = card.contains(document.activeElement);
      card.close();
      if (hadFocus && returnFocus instanceof HTMLElement) returnFocus.focus({ preventScroll: true });
    };

    card.addEventListener('focusin', (event) => {
      if (!card.contains(event.relatedTarget)) returnFocus = event.relatedTarget;
    });
    for (const button of card.querySelectorAll('[data-spo-popup-close]')) button.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && card.open) close();
    });
    window.addEventListener('scroll', () => card.open && placeAboveAtc(), { passive: true });

    if (posted || forced) {
      open();
      return;
    }

    const delay = Number(card.dataset.delay || 20) * 1000;
    const scrollShare = Number(card.dataset.scroll || 50) / 100;
    const pastFirstScreen = () => window.scrollY > window.innerHeight;
    const allowed = () => !phone.matches || pastFirstScreen();
    let timeUp = false;

    window.setTimeout(() => {
      timeUp = true;
      if (allowed()) open();
    }, delay);
    const onScroll = () => {
      if (opened) return window.removeEventListener('scroll', onScroll);
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const share = max > 0 ? window.scrollY / max : 0;
      if (allowed() && (timeUp || share >= scrollShare)) open();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spo-search-head"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tabs = document.querySelector('[data-search-tabs]');
    if (!tabs || tabs.dataset.ready) return;
    tabs.dataset.ready = '1';
    const tabList = [...tabs.querySelectorAll('[role="tab"]')];
    const guidesPanel = document.getElementById('SpoSearchGuides');
    const products = () => document.getElementById('SpoSearchProducts');
    const extra = () => [...document.querySelectorAll('.spo-answer, [data-search-vehicle]')];

    const select = (tab, focus) => {
      for (const t of tabList) {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      }
      const guides = tab.id === 'SpoTabGuides';
      if (guidesPanel) guidesPanel.hidden = !guides;
      const p = products();
      if (p) {
        p.setAttribute('role', 'tabpanel');
        p.setAttribute('aria-labelledby', 'SpoTabProducts');
        p.hidden = guides;
      }
      for (const el of extra()) el.hidden = guides;
      if (focus) tab.focus();
    };
    tabs.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) select(tab, false);
    });
    tabs.addEventListener('keydown', (event) => {
      const i = tabList.indexOf(document.activeElement);
      if (i < 0) return;
      let next = -1;
      if (event.key === 'ArrowRight') next = (i + 1) % tabList.length;
      if (event.key === 'ArrowLeft') next = (i - 1 + tabList.length) % tabList.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabList.length - 1;
      if (next < 0) return;
      event.preventDefault();
      select(tabList[next], true);
    });

    // Guides: count + list from sections/spo-search-guides; the tabs show only when there is at least one.
    const load = async () => {
      try {
        const res = await fetch(tabs.dataset.guidesUrl);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const box = doc.querySelector('[data-spo-guides]');
        const n = parseInt(box?.getAttribute('data-count') || '0', 10);
        if (!box || !n) return;
        const label = tabs.querySelector('[data-guides-n]');
        if (label) label.textContent = `(${n})`;
        guidesPanel?.replaceChildren(...box.childNodes);
        const p = products();
        if (p) {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('aria-labelledby', 'SpoTabProducts');
        }
        tabs.hidden = false;
      } catch (e) {}
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 2500 });
    else window.setTimeout(load, 600);
  })();

  } catch(e) { console.error(e); }
})();
})();
